import { MEMBERSHIP_TIERS } from './MembershipTiers';

export const HOUSE_MEMBERSHIPS: string[] = [
  MEMBERSHIP_TIERS.HOUSE,
  MEMBERSHIP_TIERS.LOCAL_HOUSE,
  MEMBERSHIP_TIERS.EVERY_HOUSE,
  MEMBERSHIP_TIERS.EVERY_PLUS_HOUSE
]
